import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import clsx from 'clsx';

export type LinkTextProps = LinkProps & {
    text: string | number
}

export function LinkText ({ text, className, ...props }: LinkTextProps) {
    const cls = useStyles();

    return (
        <Link className={clsx(cls.root, className)} {...props}>{text}</Link>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.primary.main,

        textDecoration: 'none',

        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));